var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ 'uk-form-controls': !_vm.$attrs.placeholder }},[_c('date-picker',_vm._b({attrs:{"is-expanded":"","mode":"date","value":_vm.value,"disabled-dates":{ weekdays: [1, 7] },"attributes":_vm.datepickerAttr,"title-position":"left","color":"gray","model-config":{
      type: 'string',
      mask: 'DD.MM.YYYY'
    }},on:{"input":_vm.onDateSelect},model:{value:(_vm.date),callback:function ($$v) {_vm.date=$$v},expression:"date"}},'date-picker',_vm.$attrs,false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }